const device = {
  deviceModel: '设备型号',
  deviceIMEI: '设备编号',
  deviceExtra: '主机编号',
  devicePhoneNo: '电话号码',
  releaseDate: '出厂日期',
  renewalDate: '续费日期',
  finallyOnline: '最后在线',
  devicePower: '设备电量',
  onlineStatu: '在线状态',
  bandStatu: '表带状态',
  deviceImage: '设备图片',
  bandDestroy: '上下表带破损',
  bandOK: '正常',
  bandUp: '上表带破损',
  bandDown: '下表带破损',
  total: '总数',
  vacancy: '空闲',
  other: '其它',
  overView: '设备概览',
  deviceNumber: '设备数量',
  deviceStatusNormal: '正常',
  deviceStatusUnbound: '未绑定',
  incoming: '入库',
  modifyOrg: '修改机构',
  packUp: '收起',
  expand: '展开',
  IMEISearchPlaceholder: '输入IMEI号进行搜索',
  manuallyChoose: '手动选择',
  deviceExportSuccess: '文件上传成功，导入设备{total}台，重复设备{repeatNum}台',
  deviceExportFailed: '文件上传失败',
  noModifiedDevices: '尚未添加修改的设备',
  modifiedSuccess: '修改成功',
  deviceModifyTemplate: '设备修改导入模板',
  remark: '备注',
  newRemark: '新备注',
  securitySeal: '封签号',
  newSecuritySeal: '新封签号',
  changeRemark: '修改备注',
}
export default device